import { render } from "./DepositFormAirtel.vue?vue&type=template&id=08a1ac21&scoped=true"
import script from "./DepositFormAirtel.vue?vue&type=script&lang=js"
export * from "./DepositFormAirtel.vue?vue&type=script&lang=js"

import "./DepositFormAirtel.vue?vue&type=style&index=0&id=08a1ac21&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08a1ac21"]])

export default __exports__